<ng-content></ng-content>
<button
    type="button"
    class="pw-icon-hide"
    (click)="togglePasswordVisibility()"
    [ngClass]="{ 'pw-icon-show': passwordShown }"
    aria-label="Passwort ein-/ausblenden"
></button>
